// ----------------------------------------------------------------------
// <copyright file="Izenda.FlattenTreeUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action, computed, observable } from 'mobx';
import { filter } from "lodash/fp";

class FlattenTreeUIStore {
  @observable nodeList = [];

  @computed
  get visibleNodeList() {
    const isVisible = this.isVisible.bind(this);
    const result = filter(isVisible, this.nodeList);
    return result;
  }

  @action
  setNodes(nodes) {
    this.nodeList = nodes;
  }

  @action
  toggleCollapsibleOfNode(node) {
    const isExpanded = this.isExpanded(node);
    node.data.expand = !isExpanded;
    node.data.source.expand = !isExpanded;
  }

  isVisible(node) {
    const parent = node.parent;
    if (!parent) return true;

    const parentExpanded = this.isExpanded(parent);
    if (!parentExpanded) return false;

    return this.isVisible(parent);
  }

  /**
   * Check whether a node is expanded by user action
   * @param  {String}  key Node key
   * @return {Boolean}     True/False/Undefined
   */
  isExpanded(node) {
    return node.data.expand;
  }
}

export default FlattenTreeUIStore;



// WEBPACK FOOTER //
// ./ui/share/components/controls/LazyLoadingTreeView/Izenda.FlattenTreeUIStore.js